import createLucideIcon from '../createLucideIcon';

const Clock10 = createLucideIcon('Clock10Icon', [
  ['circle', { cx: '12', cy: '12', r: '10', key: '1mglay' }],
  ['polyline', { points: '12 6 12 12 8 10', key: 'atfzqc' }],
]);

export default Clock10;
